<template>
  <div class="settlement-details-top top" :class="{ downloadSettlement: download }">

    <div class="title">
      <div ref="refTitle" class="title-note">
        <p>
          {{ titleStr }}校内课后服务综合管理平台<span v-if="tableType == 2">{{ settleMonth }}学校确认单</span><span v-if="tableType == 2 && detailsData.portOrg != 1 && download && eduAreaCode =='440114' && !isNinthMonth"> - {{ isTrueTally == 0 ? '通用账单' : '实际账单' }}</span><span v-if="tableType == 3 && type == 1">（{{ projectName }}）</span><Tag
            v-if="tableType == 2 && detailsData.portOrg != 1 && !download && eduAreaCode =='440114' && !isNinthMonth"
            :color="isTrueTally == 0 ? 'default' : 'primary'"
            style="margin-left: 32px"
          >{{ isTrueTally == 0 ? '通用账单' : '实际账单' }}</Tag>
        </p>
        <p v-if="tableType == 1">{{ settleMonth }}{{ topTitleName }}<span v-if="tableType == 1 && detailsData.portOrg != 1 && download && eduAreaCode =='440114' && !isNinthMonth"> - {{ isTrueTally == 0 ? '通用账单' : '实际账单' }}</span><Tag
          v-if="tableType == 1 && detailsData.portOrg != 1 && !download && eduAreaCode =='440114' && !isNinthMonth"
          :color="isTrueTally == 0 ? 'default' : 'primary'"
          style="margin-left: 32px"
        >{{ isTrueTally == 0 ? '通用账单' : '实际账单' }}</Tag></p>
        <p v-if="tableType == 3 && type == 1">{{ settleMonth }}教育局审批单</p>
      </div>
      <div v-if="detailsData.portOrg != 1 && !download && eduAreaCode =='440114'&& !isNinthMonth" class="toggle">
        <Button
          :type="isTrueTally == 0 ? 'primary' : 'info'"
          @click="handleToggle"
        >{{
          isTrueTally == 0 ? '切换至实际分账结算单' : '切换至通用账单结算单'
        }}</Button>
      </div>
      <div
        v-if="tableType == 1 && detailsData.portOrg != 1 && tablePortOrg != 'edu' && !download"
        class="edu-main"
      >
        <div class="edu-main-box">
          {{ detailsData.eduName }}
        </div>
      </div>
    </div>
    <div
      v-if="tableType == 1 && portOrg == 0&&!download"
      class="tab-block"
    >
      <Tabs v-model="billPlatfromMode" type="card">
        <TabPane label="平台账单模式（服务学校模式）" name="3"></TabPane>
        <TabPane label="平台账单模式（单服务学校模式）" name="1"></TabPane>
        <TabPane label="收款单位账单模式" name="2"></TabPane>
      </Tabs>
    </div>
    <SettlementDetailsSearch
      v-if="tableType == 3 && type == 1"
      :begin-time="detailsData.beginTime"
      :details-data="detailsData"
      @on-finish="onSearchFinish"
    ></SettlementDetailsSearch>
    <div class="mian">
      <p v-if="tableType != 3">
        <span>{{ tableType == 1 ? '课程提供方' : '学校' }}</span>{{ orgName }}
        <Button
          v-if="settleAttachmentExShow || settleAttachmentShow"
          type="info"
          style="margin-left: 16px"
          size="small"
          @click="handleOpenScanningModal('show')"
        >查看结算扫描件</Button>
      </p>
      <p v-if="tableType == 1&&billPlatfromMode!=='3'"><span>收款单位</span>{{ detailsData.settlementSheetOrgName }}</p>
      <p v-if="tableType != 2"><span>截止日期</span>{{ sTime }}</p>
      <p><span>金额</span>人民币元</p>
      <p v-if="tableType == 3 && type == 1"><span>结算类型</span>机构结算</p>
      <p v-if="download"><span>下载时间</span>{{ downloadTime }}</p>
      <div v-if="!download" class="btn-box">
        <Button
          v-if="isShowOpenScnBtn"
          type="info"
          style="margin-right: 16px"
          @click="handleOpenScanningModal('edit')"
        >上传结算扫描件</Button>

        <Button
          v-if="showAdminCfmBtn&&billPlatfromMode!=='3'"
          type="success"
          style="margin-right: 16px"
          @click="handleAdminCfm"
        >账单无误，运营提交确认</Button>
        <Button
          v-if="showAdminCfmFailBtn&&billPlatfromMode!=='3'"
          type="error"
          style="margin-right: 16px"
          @click="handleAdminFail"
        >账单有误，撤回提交</Button>
        <!-- <Button
          v-if="showOrgCfmFailBtn"
          v-auth="`CONFIRM_SETTLEMENT`"
          type="error"
          style="margin-right: 16px"
          @click="handleOrgFail"
        >账单有误，延时结算</Button> -->
        <!-- <Button
          v-if="showOrgCfmBtn"
          v-auth="`CONFIRM_SETTLEMENT`"
          type="info"
          style="margin-right: 16px"
          @click="handleOrgCfm"
        >核销无误，确认账单</Button>
        -->
        <Button
          v-if="showAdminCfm&&billPlatfromMode!=='3'"
          type="success"
          style="margin-right: 16px"
          disabled
        >{{ '账单已确认' }}</Button>
        <!-- <Button
          v-if="showOrgCfm"
          type="success"
          style="margin-right: 16px"
          disabled
        >{{ '机构已确认' }}</Button> -->
        <!-- <Button
          v-if="isCheckBtn && !isRejectSta"
          type="error"
          style="margin-right: 16px"
          @click="handleClickConfirm(1)"
        >账单有误，延时结算</Button> -->
        <Button
          v-if="isCheckBtn && chechAuthFun()&&billPlatfromMode!=='3'"
          class="org"
          type="info"
          style="margin-right: 16px"
          @click="handleClickConfirm(2)"
        > {{ checkBtnStr }}</Button>

        <Button
          v-if="showCancelAcademicBatchBtn"
          class="btn-download"
          type="error"
          style="margin-right: 16px"
          @click="handleAcademicBatchCancel"
        >取消教务确认</Button>

        <Button
          v-if="showAcademicBatchBtn"
          v-auth="`ACADEMIC_AFFAIRS_CONFIRMATION`"
          class="btn-download"
          type="primary"
          style="margin-right: 16px"
          @click="handleAcademicBatch"
        >教务确认账单</Button>
        <Button
          v-if="!download&&portOrg !=3&&!showOrgCfm&&tableData.length>0"
          class="btn-download"
          type="primary"
          style="margin-right: 16px"
          @click="handleDownload"
        >下载</Button>
        <!-- <Button
          v-if="!download && (portOrg == 0) && tableType!= 3"
          class="btn-download"
          type="info"
          style="margin-right: 16px"
          @click="handleDownloadRec"
        >操作日志</Button>

        <Button
          v-if="!download && (portOrg ==3 || portOrg ==2) "
          v-auth="`CONFIRM_SETTLEMENT`"
          class="btn-download"
          type="info"
          style="margin-right: 16px"
          @click="handleDownloadRec"
        >操作日志</Button> -->
        <Dropdown v-show="showAdminMoveBtn" placement="bottom-end" transfer-class-name="settlement-move" :transfer="true">
          <a href="javascript:void(0)">
            更多
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem v-if="showResetBtn"><p @click="handleResetBill">数据变动，账单需重新生成</p></DropdownItem>
            <DropdownItem v-if="!download && (portOrg == 0) && tableType!= 3"><p @click="handleDownloadRec">操作日志</p></DropdownItem>
            <DropdownItem v-if="!download && (portOrg ==3 || portOrg ==2) && tableType == 1 " v-auth="`PROVIDER_CONFIRMATION`"><p @click="handleDownloadRec">操作日志</p></DropdownItem>
            <DropdownItem v-if="!download && (portOrg ==3 || portOrg ==2) && tableType == 2 "><p @click="handleDownloadRec">操作日志</p></DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div v-if="showIsShowZeroBox" class="is-zero">
        <Checkbox v-model="isShowZero">不显示0元账单</Checkbox>
      </div>
    </div>
    <Modal
      v-model="modal"
      :title="'核销无误提示'"
      :closable="false"
      :mask-closable="false"
    >
      <p>

        确认账单即表示对本周期的账款确认无误，确认后系统即将安排本周期账款的结算处理，是否确认该账单？

      </p>
      <!-- <p v-show="action == 1">确认二次复核申请？</p> -->
      <p>请输入{{ phoneNo | fliterPhone }}收到的验证码，进行验证操作。</p>
      <div class="input-main">
        <Input
          v-model="phoneCode"
          placeholder="请输入短信验证码"
          style="width: 300px"
        ></Input>
        <p class="msg-text" @click="handleSend">{{ msgText }}</p>
      </div>
      <p class="msg-error">{{ errorStr }}</p>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">确定</Button>
      </div>
    </Modal>
    <ScanningMoadl
      v-if="!download"
      :bill-platfrom-mode="billPlatfromMode"
      :settle-month="detailsData.settleMonth"
      :org-id="detailsData.orgId"
      :sheet-id="detailsData.sheetId"
      :type-modal="scanningType"
      :settle-attachment-ex="settleAttachmentExShow"
      :settle-attachment="settleAttachmentShow"
      :show="showScanningMoadl"
      :statement-id="detailsData.sheetId"
      @on-cancel="onCloseScanningMoadl"
      @on-finish="onScannigFinish"
    ></ScanningMoadl>
    <ResetBillingSms ref="resetBillingSmsRef" :title-str="titleStr" :begin-time="detailsData.beginTime" :statement-id="statementId" @on-reset="onResetBilling"></ResetBillingSms>
    <RecModal ref="recModalRef" :code-type-map="codeTypeMap" :has-download="true"></RecModal>
    <AdminCheck
      ref="adminCheckRef"
      @on-uploadStaSts="onUploadStaSts"
    ></AdminCheck>
    <AcademicAffairsCheck ref="academicAffairsCheckRef"></AcademicAffairsCheck>
    <OrgCheck ref="0rgCheckRef"></OrgCheck>
    <SettlementNoDownloadModal ref="settlementNoDownloadModal" :table-data="tableDataForNoConfirm"></SettlementNoDownloadModal>
  </div>
</template>

<script>

import SettlementDetailsSearch from './SettlementDetailsSearch.vue';
import ScanningMoadl from './ScanningMoadl.vue';
import ResetBillingSms from './ResetBillingSms.vue';
import RecModal from '@c/RecModal.vue';
import AcademicAffairsCheck from './AcademicAffairsCheck.vue';
import common from '@/request/common/index';
import orderCenterApi from '@/request/orderCenter/index.js';
import { mapState, mapActions } from 'vuex';
import { getTodayDate } from '@/utils/moment';
import BigNumber from 'bignumber.js';
import AdminCheck from './AdminCheck.vue';
import OrgCheck from './OrgCheck.vue';
import SettlementNoDownloadModal from './SettlementNoDownloadModal.vue';
import { fliterPhone, add, getYearMonthDate, getSortDate } from '@/utils/utils';
export default {
  components: {
    SettlementDetailsSearch,
    ScanningMoadl,
    ResetBillingSms,
    AdminCheck,
    AcademicAffairsCheck,
    OrgCheck,
    SettlementNoDownloadModal,
    RecModal
  },
  inject: ['detailsData', 'tableType', 'type', 'selectionTableRows'],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    // 选中的表格数据
    download: {
      type: Boolean,
      default: false
    },
    titleStr: {
      type: String,
      default: ''
    },
    // 广州市花都区： 440114
    eduAreaCode: {
      type: String,
      default: ''
    },
    ApprovalModeId: {
      type: String,
      default: ''
    }

    // phoneNo: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {

      phoneNo: '',
      // tableType: 1: 运营平台 - 机构端->机构 2:运营平台 - 学校端 ->学校 3:教育局
      showAdminMoveBtn: false,
      modal: false,
      showScanningMoadl: false,
      phoneCode: '',
      msgText: '获取验证码',
      errorStr: '',
      action: 1, // 1: 延时结算  2: 核销，确认  0:详情
      timer: null,
      credential: '', // 短信凭证 token
      statementId: this.$route.query.statementId,
      approvalSts: this.$route.query.approvalSts,
      nodeEnum: Number(this.$route.query.nodeEnum),
      showBtn: true, // 显示审核、撤销按钮
      portOrg: localStorage.getItem('portOrg'),
      settleAttachment: null,
      settleAttachmentForAll: null, // 服务学校模式下的
      settleAttachmentEx: null,
      settleAttachmentExForAll: null, // 服务学校模式下的
      scanningType: '',
      routeName: '',
      statementSts: '',
      isShowZero: true,
      tablePortOrg: this.$route.meta.tablePortOrg,
      downloadTime: getTodayDate('YYYY-MM-DD HH:mm:ss'),
      checkTimeOut: null,
      billPlatfromMode: this.tableType == 1 && localStorage.getItem('portOrg') == 0 ? '3' : '1', // 对于机构结算单的 1：平台账单模式 2：收款单位账单模式
      codeTypeMap: {
        SCHOOL_SETTLEMENT_SHEET_DOWN_FILE: '学校确认单下载',
        ORG_SETTLEMENT_SHEET_DOWN_FILE: '账单下载',
        CONFIRM_SETTLE_SHEET: '运营操作账单确认',
        REVOKE_SETTLE_SHEET: '运营操作账单撤回',
        RESET_BILLING_OPERATIONS: '运营账单重新生成',
        ORG_DELAY_SETTLE: '机构延迟结算账单',
        ORG_CONFIRM_SETTLE_SHEET: '机构确认账单',
        ACADEMIC_AFFAIRS_CONFIRM_SETTLE_SHEET: '教务确认账单'
      }
    };
  },
  computed: {
    ...mapState({
      // nodeEnum: state => state.orderCenter.nodeEnum,
      audit: state => state.orderCenter.audit,
      isTrueTally: state => state.orderCenter.isTrueTally,
      authMap: state => state.authMap,
      projectName: state => state.projectName

    }),
    settleAttachmentShow() {
      return this.billPlatfromMode === '3' ? this.settleAttachmentForAll : this.settleAttachment;
    },
    settleAttachmentExShow() {
      return this.billPlatfromMode === '3' ? this.settleAttachmentExForAll : this.settleAttachmentEx;
    },
    sTime() {
      return this.tableType != 2 && this.detailsData && this.detailsData.endTime ? this.detailsData.endTime.split(' ')[0] : '';
    },
    orgName() {
      return this.detailsData.tableType == 1 ? this.detailsData.data.orgName : this.detailsData.data.schName;
    },
    orgId() {
      return this.detailsData.tableType == 1 ? this.detailsData.data.orgId : this.detailsData.data.schId;
    },
    beginTime() {
      const day = this.detailsData.beginTime.split('-');
      return `${day[0]}年${day[1]}月`;
    },
    settleMonth() {
      let beginTime = '';
      let endTime = '';
      if (this.tableType == 1 || this.tableType == 3) {
        // const { beginTime, endTime } = this.detailsData;
        beginTime = this.detailsData.beginTime;
        endTime = this.detailsData.endTime;
      } else if (this.tableData.length > 0) {
        const beginDateList = [];
        const endDateList = [];
        this.tableData.forEach(item => {
          beginDateList.push(item.beginTime);
          endDateList.push(item.endTime);
        });
        beginTime = getSortDate(beginDateList)[0];
        endTime = getSortDate(endDateList).pop();
      } else {
        return '-';
      }

      const { year: beginYear, month: beginMonth } = getYearMonthDate(beginTime);
      const { year: endYear, month: endMonth } = getYearMonthDate(endTime);
      if (!endYear || !endMonth) {
        return `${beginYear}年${beginMonth}月`;
      } else if (beginYear === endYear && beginMonth === endMonth) {
        return `${beginYear}年${beginMonth}月`;
      } else if (beginYear === endYear) {
        return `${beginYear}年${beginMonth}~${endMonth}月`;
      } else {
        return `${beginYear}年${beginMonth}月~${endYear}年${endMonth}月`;
      }
    },
    // isCheckBtn() {
    //   return [1, 2].includes(this.nodeEnum) && this.showBtn;
    // },
    isCheckBtn() {
      return [2, 3].includes(this.approvalSts) && [2, 3].includes(Number(this.portOrg)) && !this.detailsData.isFromSchoolEduSure && this.tableType == 1 && this.showBtn && !this.download || this.isCheckEduBtn;
    },

    isCheckEduBtn() {
      return [4, 5].includes(this.approvalSts) && [1].includes(Number(this.portOrg)) && this.showBtn && this.ApprovalModeId != '210001' && !this.download;
    },
    isRejectSta() {
      return this.audit.length > 0 && this.audit[this.audit.length - 1]['checkResult'] == 2;
    },
    isShowOpenScnBtn() {
      return this.tableType == 1 && this.tablePortOrg != 'edu' && this.portOrg != 1 && !this.download && !this.detailsData.isFromSchoolEduSure;
    },
    showScanBtn() {

    },
    // 运营端 显示确认按钮
    showAdminCfmBtn() {
      return this.detailsData.tableType == 1 && this.tablePortOrg != 'edu' && this.detailsData.portOrg == 0 && this.approvalSts == 1 && !this.download;
    },
    // 运营端 显示更多按钮
    showResetBtn() {
      return this.detailsData.tableType == 1 && this.tablePortOrg != 'edu' && this.detailsData.portOrg == 0 && this.approvalSts == 0 && !this.download;
    },
    // 运营端 显示撤回按钮
    showAdminCfmFailBtn() {
      return this.detailsData.tableType == 1 && this.tablePortOrg != 'edu' && this.detailsData.portOrg == 0 && this.approvalSts == 2 && !this.download;
    },
    // 运营端显示 确认状态按钮
    showAdminCfm() {
      return this.detailsData.tableType == 1 && this.tablePortOrg != 'edu' && this.detailsData.portOrg == 0 && this.approvalSts > 2 && !this.download;
    },
    // 机构端 显示确认按钮
    // showOrgCfmBtn() {
    //   return this.detailsData.tableType == 1 && this.tablePortOrg != 'edu' && (this.detailsData.portOrg == 3 || this.detailsData.portOrg == 2) && this.statementSts === 0 && !this.download;
    // },
    // 机构显示 确认状态按钮
    showOrgCfm() {
      return this.detailsData.tableType == 1 && this.tablePortOrg != 'edu' && this.detailsData.portOrg == 3 && this.approvalSts > 2 && !this.download;
    },
    // 机构端 显示账单有误，延时结算 按钮
    // showOrgCfmFailBtn() {
    //   return this.detailsData.tableType == 1 && this.tablePortOrg != 'edu' && (this.detailsData.portOrg == 3 || this.detailsData.portOrg == 2) && this.statementSts == 0 && !this.download;
    // },
    // 花都区 机构端
    // isHuaDuOrg() {
    //   return this.eduAreaCode == '440114' && this.detailsData.portOrg == 3;
    // },
    showIsShowZeroBox() {
      return this.detailsData.tableType == 3 && !this.download;
    },
    // 是否是 2022年8月份以后
    isNinthMonth() {
      const day = this.detailsData.settleMonth.split('-');
      const dayNum = String(day[0]) + String(day[1]);
      return Number(dayNum) > 202208;
    },
    isShowMoreBtn() {
      return;
    },
    // 显示 教务批量审批按钮
    showAcademicBatchBtn() {
      return this.portOrg == 2 && !this.download && this.detailsData.tableType == 2;
    },
    // 显示 取消教务批量审批按钮
    showCancelAcademicBatchBtn() {
      return this.portOrg == 2 && !this.download && this.detailsData.tableType == 2;
    },
    // isAcademicCheck() {
    //   return this.tableData.filter(item => { return item._disabled === true; }).length != this.tableData.length;
    // },
    checkBtnStr() {
      const str = '核销无误，确认账单';
      if (this.approvalSts == 2) {
        return '待机构确认';
      }
      if (this.approvalSts == 3) {
        return '待收款单位确认';
      }
      if (this.approvalSts == 4) {
        return '待教育局初审';
      }
      if (this.approvalSts == 5) {
        return '待教育局复审';
      }
      return str;
    },
    // 还没待运营确认的账单列表
    tableDataForNoConfirm() {
      return this.tableData.filter(item => {
        return item.approvalSts <= 1 && item.orgName != '合计';
      });
    },
    topTitleName() {
      return this.billPlatfromMode === '3' ? '平台服务费结算单' : '机构结算单';
    }
  },

  watch: {
    billPlatfromMode: {
      immediate: true,
      handler(newVal) {
        console.log(newVal, '拿到的新的电机的-1231---');
        this.$emit('getChangeBillPlatfromMode', newVal);
      }
    }
  },
  created() {
    // if (this.tableType == 1 && this.portOrg == 0) {
    //   this.billPlatfromMode = '3';
    // }
    if (!this.download && this.tableType == 1) {
      this.getStatemsheetImg();
      +this.portOrg === 0 ? this.getStatemsheetImgForAll() : '';
    }
    if (this.tableType == 1 && (this.detailsData.portOrg != 1)) {
      this.statementSts = this.detailsData.statementSts;
    }
    this.approvalSts = this.detailsData.approvalSts;
    if (this.tableType == 1 && this.detailsData.portOrg != 1 && this.tablePortOrg != 'edu' && !this.download) {
      this.$emit('on-sdetails', {
        eduId: this.detailsData.eduId
      });
    }
    this.getUserPhone();
  },
  mounted() {
    this.routeName = this.$route.name;
    const moveDom = document.querySelector('.settlement-move').querySelectorAll('.ivu-dropdown-item');
    const validDoms = [...moveDom].filter(item => { return item.style.display != 'none'; });
    if (validDoms.length > 0) {
      this.showAdminMoveBtn = true;
    }
  },
  destroyed() {
    clearTimeout(this.checkTimeOut);
  },
  methods: {
    ...mapActions('orderCenter', [
      'updateTrueTally'
    ]),
    chechAuthFun() {
      if (this.approvalSts == 2 && this.authMap['PROVIDER_CONFIRMATION'] == 1) {
        return true;
      }
      if (this.approvalSts == 3 && this.authMap['PAYEE_CONFIRMATION'] == 1) {
        return true;
      }
      if ([4, 5].includes(this.approvalSts) && this.authMap['EDU_CONFIRMATION'] == 1) {
        return true;
      }
      return false;
    },
    // 获取用户的手机号
    async getUserPhone() {
      const res = await common.getUserInfoApi();
      if (res.status === 200) {
        this.phoneNo = res.message.phone;
      }
    },
    // 查询分账单扫描件(服务学校模式)
    async getStatemsheetImgForAll() {
      const { orgId, settleMonth } = this.detailsData;
      const parameter = {
        types: [1, 2], // 1=机构扫描件 2=平台扫描件
        objId: add(orgId, settleMonth.replace('-', ''))// 机构id+年月
      };
      console.log(orgId, settleMonth.replace('-', ''), parameter);
      const res = await orderCenterApi.getListByObjIdAndTypesApi(parameter);
      if (res.status == 200) {
        const orgList = [];
        const schoolList = [];
        res.message.forEach(item => {
          if (item.fileType == 1) {
            orgList.push(item.fileId);
          } else if (item.fileType == 2) {
            schoolList.push(item.fileId);
          }
        });
        this.settleAttachmentForAll = orgList.join(';');
        this.settleAttachmentExForAll = schoolList.join(';');
      }
    },
    // 获取结算账单扫描件
    async getStatemsheetImg() {
      console.log(this.detailsData, '拿到的数据---');
      let res; const parameter = {
        sheetId: this.detailsData.sheetId
      };
      if (this.portOrg == 0) {
        //  res = await orderCenterApi.getStatementSheetImgByAdmin(parameter);
      }
      if (this.portOrg == 3) {
        //  res = await orderCenterApi.getStatementSheetImgByOrg(parameter);
      }
      if (this.portOrg == 1) {
        //  parameter.statementId = this.statementId;
        //  res = await orderCenterApi.getStatementSheetImgByEdu(parameter);
      }
      res = await orderCenterApi.getBillReviewForm(parameter);
      if (res.status == 200) {
        const { settleAttachment, settleAttachmentEx } = res.message;
        this.settleAttachment = settleAttachment;
        this.settleAttachmentEx = settleAttachmentEx;
      }
    },

    onCloseScanningMoadl() {
      this.showScanningMoadl = false;
    },
    onResetBilling() {
      location.reload();
    },
    // 提交附近完成
    onScannigFinish() {
      if (!this.download) {
        this.onCloseScanningMoadl();
        this.billPlatfromMode === '3' ? this.getStatemsheetImgForAll() : this.getStatemsheetImg();
      }
    },
    // 切换分账单类型
    handleToggle() {
      this.updateTrueTally(this.isTrueTally == 1 ? 0 : 1);
    },
    // 审批确认
    handleClickConfirm(action) {
      // let totalFee = this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalFee'] : 0;
      // let totalDivideAmt = totalFee ? new BigNumber(totalFee.replace(/,/g, '')) : 0

      // console.log(totalDivideAmt)
      this.phoneCode = '';
      this.action = action;

      // 如果是机构端的待机构确认，不用进行验证码验证，直接审批
      if (action === 2 && (+this.portOrg === 3 || +this.portOrg === 2) && +this.approvalSts === 2) {
        this.$Modal.confirm({
          title: '核销无误提示',
          content: '<p>确认账单即表示对本周期的账款确认无误，确认后系统即将安排本周期账款的结算处理，是否确认该账单？</p>',
          onOk: () => {
            this.orgUpdateProviderApproval();
          }
        });
      } else {
        this.modal = true;
      }
    },
    // 点击 数据变动，账单需重新生成
    handleResetBill() {
      this.$refs.resetBillingSmsRef.handleShow();
    },
    // 运营端 机构端 提交撤回状态更改跳转
    handleLoadRoute() {
      const detailsData = JSON.parse(JSON.stringify(this.detailsData));
      detailsData.approvalSts = this.approvalSts;
      const routeName = this.$route.name;
      const routeUrl = this.$router.resolve({
        name: routeName,
        query: {
          detailsData: encodeURIComponent(JSON.stringify(detailsData))
        }
      });
      window.location.href = routeUrl.href;
      window.location.reload();
    },
    // 教育局端- 审批 驳回后 链接状态更改
    handleEduLoadRoute() {
      const routeName = this.$route.name;
      const query = this.$route.query;
      const detailsData = JSON.parse(JSON.stringify(this.detailsData));
      const routeUrl = this.$router.resolve({
        name: routeName,
        query: {
          nodeEnum: 0,
          detailsData: encodeURIComponent(JSON.stringify(detailsData)),
          statementId: query.statementId
        }
      });
      window.location.href = routeUrl.href;
    },
    // 机构端提交
    handleOrgCfm() {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否提交确认？</p>',
        onOk: () => {
          console.log('{ statementId: this.statementId }', { statementId: this.detailsData.sheetId, orgId: this.orgId });
          this.$Spin.show();
          orderCenterApi.saveOrgSettlementSheetconfirm({ statementId: this.detailsData.sheetId, orgId: this.orgId }).then(res => {
            this.$Spin.hide();
            if (res.status == 200) {
              this.statementSts = 1;
              this.handleLoadRoute();
              this.$Message.success('提交成功');
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 机构端- 账单有误，延时结算
    handleOrgFail() {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否延时结算？</p>',
        onOk: () => {
          console.log('{ statementId: this.statementId }', { statementId: this.detailsData.sheetId, orgId: this.orgId });
          this.$Spin.show();
          orderCenterApi.revokeStatementStsByOrg({ statementId: this.detailsData.sheetId, orgId: this.orgId }).then(res => {
            this.$Spin.hide();
            if (res.status == 200) {
              this.statementSts = 5;
              this.handleLoadRoute();
              this.$Message.success('延时结算操作成功');
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 教务 批量确认
    handleAcademicBatch() {
      const list = this.selectionTableRows();
      if (list.length == 0) {
        this.$Message.warning('请先选择要确认的数据～');
        return null;
      }
      const tag = list.every(item => {
        return +item.approvalSts === 0;
      });
      if (!tag) {
        this.$Message.warning('仅支持待教务确认的账单进行批量确认。');
        return null;
      }
      this.$Modal.info({
        title: '提示',
        width: 560,
        content: `<div><p  style="font-weight:bold;font-size:18px;line-height:26px;">确认前，请仔细核对确认单。确认后，将进行<span style="color:rgb(217, 0, 27);font-size:18px;line-height:26px;">账单锁定</span>操作，<span style="color:rgb(217, 0, 27);font-size:18px;line-height:26px;">不可再调整课时</span>！</p><p style="text-align:center;margin-top:26px;">请确认，您已了解并知晓上说明！</p></div>`,
        okText: '我已了解',
        onOk: () => {
          this.$refs.academicAffairsCheckRef.handleShow(1);
        }
      });
    },
    // 教务  批量取消教务确认
    handleAcademicBatchCancel() {
      console.log(this.selectionTableRows(), '选中的项目----');
      const list = this.selectionTableRows();
      if (list.length == 0) {
        this.$Message.warning('请先选择要取消教务确认的数据～');
        return null;
      }
      const tag = list.every(item => {
        return +item.approvalSts === 1;
      });
      if (!tag) {
        this.$Message.warning('仅支持【待运营确认】的账单进行取消确认。');
        return null;
      }
      this.$refs.academicAffairsCheckRef.handleShow(2);
    },

    onUploadStaSts() {
      this.approvalSts = 2;
      this.handleLoadRoute();
    },
    // 运营提交
    handleAdminCfm() {
      this.$refs.adminCheckRef.handleShow({
        sheetId: this.detailsData.sheetId,
        totalFee: this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalFee'] : 0,
        totalDivideAmt: this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalDivideAmt'] : 0
      });
    },
    // 运营撤回
    handleAdminFail() {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否撤回？</p>',
        onOk: () => {
          this.$Spin.show();
          const totalFee = this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalFee'] : 0;
          const totalDivideAmt = totalFee ? new BigNumber(totalFee.replace(/,/g, '')) : 0;
          orderCenterApi.uploadOperationRevocationApproval({ sheetId: this.detailsData.sheetId, totalDivideAmt: totalDivideAmt ? totalDivideAmt.times(100) * 1 : 0 }).then(res => {
            this.$Spin.hide();
            if (res.data.status == 200) {
              this.approvalSts = 1;
              this.$Message.success('撤回成功');
              this.handleLoadRoute();
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 查询账单状态
    async getSettlementSheetStatus(sheetId) {
      return new Promise(async(resolve, reject) => {
        const res = await orderCenterApi.getBillReviewForm({
          sheetId
        });
        if (res.status == 200) {
          resolve(res.message.approvalSts);
        } else {
          reject();
        }
      });
    },
    // 检查学校确认单机构账单状态
    checkSchStatementSts() {
      const list = this.tableData.filter(item => {
        return item.approvalSts == 0 && item.orgName != '合计' && item.settleAvailAmt != '0.00';
      });
      if (list.length > 0 && this.portOrg != 0) {
        const orgs = list.map(item => { return item.orgName; });
        this.$Message.warning(`${list[0]['orgName']}的账单未确认，不可下载学校确认单`);
        return null;
      }
      return true;
    },
    // 下载
    async handleDownload() {
      if (this.portOrg == 2 && this.tableType == 2) {
        const key = this.tableData.findIndex(item => { return item.approvalSts === 0; });
        console.log(this.tableData, '拿到的所有账单----345353');
        if (key != -1) {
          this.$Message.warning('请完成所有账单的确认后，再进行下载。');
          return null;
        }
      }
      if (this.billPlatfromMode === '3') {
        if (this.tableDataForNoConfirm.length > 0) {
          this.$refs.settlementNoDownloadModal.openModal();
          return null;
        }
      } else if (this.tablePortOrg != 'edu' && [0, 2, 3].includes(Number(this.portOrg)) && this.tableType != 2) {
        const approvalSts = await this.getSettlementSheetStatus(this.detailsData.sheetId);

        if (approvalSts < 2 && +this.portOrg !== 0) {
          this.$Message.warning('账单未确认，暂时无法提供下载');
          return null;
        }
      }
      if (this.tableType == 2 && !this.checkSchStatementSts()) {
        return null;
      }
      const type = this.tableType == 3 && this.type == 1 ? 2 : 1;
      // this.isTrueTally == 0 ? '通用账单' : '实际账单'
      this.detailsData.portOrg != 1 && this.eduAreaCode == '440114';
      let tallyStr = '';
      if (this.isNinthMonth) {
        tallyStr = (this.detailsData.portOrg != 1 && this.eduAreaCode == '440114') ? '' : '';
      } else {
        tallyStr = (this.detailsData.portOrg != 1 && this.eduAreaCode == '440114') ? (this.isTrueTally == 0 ? '（通用账单）' : '（实际账单）') : '';
      }
      this.$nextTick(() => {
        this.$emit('on-download', {
          type,
          titleStr: `${this.orgName}${this.settleMonth}${this.tableType == 2 ? '学校确认单' : this.portOrg == 0 && this.billPlatfromMode == 1 ? '平台结算单' : this.billPlatfromMode == 3 ? '平台服务费结算单' : '机构结算单'}${tallyStr}`,
          schId: this.detailsData.data.schId,
          orgId: this.detailsData.data.orgId,
          tableType: this.tableType,
          beginTime: this.detailsData.settleMonth,
          bankId: this.detailsData.bankId

        });
      });
      // this.$refs.refTitle.innerHTML.replace(/<.*?>/g, "").trim()
    },
    // 操作日志
    handleDownloadRec() {
      const { data, settleMonth, tableType } = this.detailsData;
      const objectId = +tableType === 1 ? this.detailsData.sheetId : `${+tableType === 1 ? data.orgId : data.schId}#${settleMonth}`;
      let recTypes = '';
      switch (+tableType) {
        case 1:
          recTypes = +this.portOrg === 0 ? 'ORG_SETTLEMENT_SHEET_DOWN_FILE,CONFIRM_SETTLE_SHEET,REVOKE_SETTLE_SHEET,RESET_BILLING_OPERATIONS' : 'ORG_SETTLEMENT_SHEET_DOWN_FILE,ORG_DELAY_SETTLE,ORG_CONFIRM_SETTLE_SHEET';
          break;
        default:
          recTypes = +this.portOrg === 0 ? 'SCHOOL_SETTLEMENT_SHEET_DOWN_FILE,ACADEMIC_AFFAIRS_CONFIRM_SETTLE_SHEET' : 'SCHOOL_SETTLEMENT_SHEET_DOWN_FILE,ACADEMIC_AFFAIRS_CONFIRM_SETTLE_SHEET';
          break;
      }
      this.$refs.recModalRef.handleShow({
        objectId,
        accurateQueryRecTypes: recTypes
      });
    },
    // 搜索
    onSearchFinish(val) {
      val.isShowZero = this.isShowZero ? 0 : 1;
      this.$emit('on-search-finish', val);
    },
    onEduChange(edu) {
      this.$emit('on-sdetails', {
        eduId: edu.eduId
      });
    },
    handleCancel() {
      this.modal = false;
    },
    async handleOk() {
      if (!this.phoneCode) {
        return this.$Message.warning('请输入短信验证码');
      }
      if (this.approvalSts == 3) {
        this.orgUpdatePayeeApproval();
      } else if (this.approvalSts == 2) {
        this.orgUpdateProviderApproval();
      } else if (this.approvalSts == 4) {
        this.eduPreApproval();
      } else if (this.approvalSts == 5) {
        this.eduApproval();
      }
    },
    handleOpenScanningModal(type) {
      this.showScanningMoadl = true;
      this.scanningType = type;
    },
    // 发送短信
    async handleSend() {
      if (this.msgText != '获取验证码') {
        return null;
      }
      this.credential = await this.sendMsg();

      let second = 30;
      this.msgText = `${second}s后获取`;
      this.timer = setInterval(() => {
        if (second == 0) {
          clearInterval(this.timer);
          this.msgText = '获取验证码';
          return false;
        }
        second--;
        this.msgText = `${second}s后获取`;
      }, 1000);
    },
    async sendMsg() {
      return new Promise(async resolve => {
        const res = await orderCenterApi.sendRecipientApprovalVerificationSms({
          phone: this.phoneNo
        });
        if (res.status == 200) {
          this.$Message.success('发送成功，请注意查收');
          resolve(res.message);
        }
      });
    },
    // 收款方 确认账单
    async orgUpdatePayeeApproval() {
      this.$Spin.show();
      const totalFee = this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalFee'] : 0;
      const totalDivideAmt = totalFee ? new BigNumber(totalFee.replace(/,/g, '')) : 0;
      const res = await orderCenterApi.orgUpdatePayeeApproval({
        totalDivideAmt: totalDivideAmt ? totalDivideAmt.times(100) * 1 : 0,
        sheetId: this.detailsData.sheetId,
        verifyCode: this.phoneCode
      });
      this.$Spin.hide();
      if (res.status == 200) {
        // if (this.ApprovalModeId == 210001) {
        this.approvalSts = 99;
        // } else {
        this.showBtn = false;
        // }
        this.modal = false;
        this.handleLoadRoute();
      } else {
        this.errorStr = res.data.error;
      }
    },
    // 教育局预审批
    async eduPreApproval() {
      this.$Spin.show();
      const totalFee = this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalFee'] : 0;
      const totalDivideAmt = totalFee ? new BigNumber(totalFee.replace(/,/g, '')) : 0;
      const res = await orderCenterApi.eduPreApproval({
        totalDivideAmt: totalDivideAmt ? totalDivideAmt.times(100) * 1 : 0,
        sheetId: this.detailsData.sheetId,
        verifyCode: this.phoneCode
      });
      this.$Spin.hide();
      if (res.status == 200) {
        if (this.ApprovalModeId == 210001) {
          this.approvalSts = 5;
        } else {
          this.showBtn = false;
        }
        this.modal = false;
        this.handleLoadRoute();
      } else {
        this.errorStr = res.data.error;
      }
    },
    // 教育局审批
    async eduApproval() {
      this.$Spin.show();
      const totalFee = this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalFee'] : 0;
      const totalDivideAmt = totalFee ? new BigNumber(totalFee.replace(/,/g, '')) : 0;
      const res = await orderCenterApi.eduApproval({
        totalDivideAmt: totalDivideAmt ? totalDivideAmt.times(100) * 1 : 0,
        sheetId: this.detailsData.sheetId,
        verifyCode: this.phoneCode
      });
      this.$Spin.hide();
      if (res.status == 200) {
        this.approvalSts = 99;
        this.modal = false;
        this.handleLoadRoute();
      } else {
        this.errorStr = res.data.error;
      }
    },
    // 提供方 确认账单
    async orgUpdateProviderApproval() {
      this.$Spin.show();
      const totalFee = this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalFee'] : 0;
      const totalDivideAmt = totalFee ? new BigNumber(totalFee.replace(/,/g, '')) : 0;
      const params = {
        totalDivideAmt: totalDivideAmt ? totalDivideAmt.times(100) * 1 : 0,
        sheetId: this.detailsData.sheetId
      };
      if ((+this.portOrg === 3 || +this.portOrg === 2)) {
        params.verifyCode = this.phoneCode;
      }
      const res = await orderCenterApi.orgUpdateProviderApproval(params);
      this.$Spin.hide();
      if (res.status == 200) {
        this.approvalSts = await this.getSettlementSheetStatus(this.detailsData.sheetId);
        if (this.approvalSts == 4) {
          this.showBtn = false;
        }
        // if (this.ApprovalModeId == 210001) {
        //   this.approvalSts = 3
        // } else {
        //   this.showBtn = false;
        //   this.approvalSts = 4
        // }
        this.modal = false;
        this.handleLoadRoute();
      } else {
        this.errorStr = res.data.error;
      }
    }
  },
  filters: {
    fliterPhone(phone) {
      if (phone) {
        return fliterPhone(phone);
      } else {
        return '--';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common';

.download .title {
  padding-top: 32px;
}
.title {
  position: relative;
  text-align: center;

  margin-bottom: 32px;
  p {
    font-size: 22px;
    font-weight: bold;
    line-height: 34px;
    span {
      font-size: 22px;
      font-weight: bold;
    }
  }
  .edu-main {
    position: absolute;
    left: 0;
    top: 0;
    .edu-main-box {
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
  }
  .toggle {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.mian {
  position: relative;
  > p {
    margin-bottom: 16px;
    span {
      font-weight: bold;
      display: inline-block;
      width: 86px;
      text-align: right;
      padding-right: 12px;
    }
  }
}
.btn-box {
  position: absolute;
  right: 32px;
  top: 50%;
  transform: translateY(-50%);
  .btn-download {
  }
}
.is-zero {
  position: absolute;
  right: 32px;
  top: 85%;
  /* transform: translateY(-50%); */
}
.input-main {
  padding: 16px 0;
  position: relative;
  width: 300px;
  .msg-text {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #488ffa;
    cursor: pointer;
  }
}
.msg-error {
  color: red;
}
/* 打印样式 */
$fontSize18: 18px;
$fontSize26: 26px;
.settlement-details-top {
  /deep/ .ivu-tag-size-default {
    background: #2db7f5;

    .ivu-tag-text {
      color: #fff;
    }
  }
  .ivu-tag-primary {
    background: #488ffa;
  }
}
.downloadSettlement {
  .title {
    margin-bottom: 16px;
    p {
      font-size: $fontSize26;
      span {
        font-size: $fontSize26;
      }
    }
  }
  .mian {
    > p {
      margin-bottom: 16px;
      font-size: $fontSize18;
      span {
        font-weight: bold;
        display: inline-block;
        width: 120px;
        text-align: right;
        padding-right: 12px;
        font-size: $fontSize18;
      }
    }
  }
}
</style>
